import { render, staticRenderFns } from "./JLjhDay.vue?vue&type=template&id=ebd2ad1a&scoped=true"
import script from "./JLjhDay.vue?vue&type=script&lang=js"
export * from "./JLjhDay.vue?vue&type=script&lang=js"
import style0 from "./JLjhDay.vue?vue&type=style&index=0&id=ebd2ad1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd2ad1a",
  null
  
)

export default component.exports